import { BookOpenCheck, ChevronRight, PlayCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { requestFirstAccessTutorialLaunch } from '@/components/onboarding/tutorial-runtime';

export default function HelpCenterPage() {
  const navigate = useNavigate();

  const handleOpenTutorial = () => {
    navigate('/financial');

    window.setTimeout(() => {
      requestFirstAccessTutorialLaunch('tour');
    }, 0);
  };

  return (
    <div className="min-h-full bg-background">
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-6 px-4 py-6 sm:px-6">
        <div className="space-y-2">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-3 py-1 text-sm font-medium text-primary">
            <BookOpenCheck className="h-4 w-4" />
            Central de Ajuda
          </div>
          <h1 className="text-3xl font-semibold tracking-tight text-foreground">
            Tutoriais e orientações
          </h1>
          <p className="max-w-2xl text-sm leading-6 text-muted-foreground">
            Encontre aqui os guias rápidos para navegar no Librattum e revisar o passo a passo
            do seu planejamento financeiro.
          </p>
        </div>

        <Card className="border-border/70 shadow-sm">
          <CardHeader className="pb-3">
            <CardTitle className="text-lg">Primeiros passos</CardTitle>
            <CardDescription>
              Revise o fluxo guiado de receitas, despesas e saldo sempre que precisar.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex flex-col gap-4 rounded-xl border border-border/70 bg-card/60 p-4 sm:flex-row sm:items-center sm:justify-between">
              <div className="space-y-1">
                <p className="text-base font-medium text-foreground">
                  1. Como realizar meu planejamento dentro do Librattum
                </p>
                <p className="text-sm text-muted-foreground">
                  Abra novamente o passo a passo completo do sistema.
                </p>
              </div>

              <Button onClick={handleOpenTutorial} className="gap-2 self-start sm:self-center">
                <PlayCircle className="h-4 w-4" />
                Passo a Passo
                <ChevronRight className="h-4 w-4" />
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
